import { JobQueries } from '@/graphql/queries/job.queries'
import { JobDetail } from '@/types/Job'

import { useGraphql } from '../useGraphql'

const useJob = (jobId?: number) => {
  return useGraphql<{ job: JobDetail }>(
    JobQueries.QUERY_KEYS.getJobDetails,
    JobQueries.getJobDetails(),
    { id: jobId },
    { enabled: !!jobId },
  )
}

export default useJob
